import { api, API, formatMoney, formatPhone, onlyDigits } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Download, Mail } from "lucide-react";
import { toast } from "sonner";

export function TelefoneEditor({ inscricao, editTel, setEditTel, onReload }) {
  const salvar = async () => {
    try {
      await api.put(`/inscricoes/${inscricao.id}`, {
        telefone: onlyDigits(editTel?.telefone || ""),
        whatsapp: onlyDigits(editTel?.whatsapp || ""),
      });
      toast.success("Telefone atualizado");
      setEditTel(null);
      onReload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  return (
    <div className="border-t pt-3 grid md:grid-cols-3 gap-2 items-end">
      <div>
        <Label>Telefone</Label>
        <Input
          value={editTel.telefone}
          onChange={(e) => setEditTel({ ...editTel, telefone: formatPhone(e.target.value) })}
          data-testid={`input-tel-${inscricao.id}`}
        />
      </div>
      <div>
        <Label>WhatsApp</Label>
        <Input
          value={editTel.whatsapp}
          onChange={(e) => setEditTel({ ...editTel, whatsapp: formatPhone(e.target.value) })}
          data-testid={`input-wa-${inscricao.id}`}
        />
      </div>
      <div className="flex gap-2">
        <Button size="sm" onClick={salvar} className="bg-[#083CA6]" data-testid={`btn-save-tel-${inscricao.id}`}>Salvar</Button>
        <Button size="sm" variant="outline" onClick={() => setEditTel(null)}>Cancelar</Button>
      </div>
    </div>
  );
}

export function InscricaoResumo({ inscricao, editTel, setEditTel, onReload }) {
  const docsEnviados = (inscricao.documentos || []).length;
  return (
    <>
      <div className="grid md:grid-cols-3 gap-3">
        <div><span className="text-slate-500">Renda:</span> <strong>{formatMoney(inscricao.renda_total)}</strong></div>
        <div><span className="text-slate-500">Faixa 1:</span> {inscricao.apta_faixa1 ? "Sim ✓" : "Não"}</div>
        <div><span className="text-slate-500">Bairro:</span> {inscricao.bairro}</div>
      </div>
      <div className="grid md:grid-cols-3 gap-3 text-xs">
        <div><span className="text-slate-500">Documentos:</span> <strong>{docsEnviados}</strong> enviado(s)</div>
        <div className="flex items-center gap-1 text-slate-500">
          <Mail className="w-3 h-3" />
          <span className="truncate">{inscricao.email || "sem e-mail"}</span>
        </div>
        <div><span className="text-slate-500">Telefone:</span> {inscricao.telefone || "—"}</div>
      </div>
      {inscricao.parecer && (
        <div className="p-3 bg-slate-50 rounded text-xs" data-testid={`cidadao-parecer-${inscricao.id}`}>
          <strong>Parecer da Secretaria:</strong> {inscricao.parecer}
        </div>
      )}
      {editTel ? (
        <TelefoneEditor inscricao={inscricao} editTel={editTel} setEditTel={setEditTel} onReload={onReload} />
      ) : (
        <div className="flex flex-wrap gap-2 pt-2 border-t">
          <Button size="sm" variant="outline" onClick={() => window.open(`${API}/inscricoes/${inscricao.id}/comprovante`, "_blank")} data-testid={`btn-comp-${inscricao.id}`}>
            <Download className="w-4 h-4 mr-1" />Comprovante
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setEditTel({ telefone: inscricao.telefone || "", whatsapp: inscricao.whatsapp || "" })} data-testid={`btn-edit-tel-${inscricao.id}`}>
            Atualizar Telefone
          </Button>
        </div>
      )}
    </>
  );
}
